import { useSyncExternalStore } from "react";

let mobileNavOpen = false;
const listeners = new Set();

export function subscribeAdminMobileNav(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function getAdminMobileNavOpen() {
  return mobileNavOpen;
}

export function setAdminMobileNavOpen(next) {
  const value = Boolean(next);
  if (value === mobileNavOpen) return;
  mobileNavOpen = value;
  listeners.forEach((listener) => listener());
}

export function toggleAdminMobileNav() {
  setAdminMobileNavOpen(!mobileNavOpen);
}

export function useAdminMobileNav() {
  return useSyncExternalStore(
    subscribeAdminMobileNav,
    getAdminMobileNavOpen,
    () => false
  );
}
